import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import NotFound from '@/pages/NotFound';
import AppLoadingState from './AppLoadingState';
import { useState } from 'react';

const AlbumRedirect = () => {
  const { albumSlug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [albumExists, setAlbumExists] = useState(false);

  useEffect(() => {
    const checkAlbumExists = async () => {
      if (!albumSlug) {
        setLoading(false);
        return;
      }

      try {
        const { data: album, error } = await supabase
          .from('albums')
          .select('id, slug, is_active, is_reserved')
          .eq('slug', albumSlug)
          .maybeSingle();

        if (error) {
          console.error('Error checking album:', error);
          setLoading(false);
          return;
        }

        if (album) {
          // Album exists regardless of status, redirect to inicio page
          setAlbumExists(true);
          navigate(`/${albumSlug}/inicio`, { replace: true });
          return;
        } else {
          // Album doesn't exist
          setAlbumExists(false);
          setLoading(false);
        }
      } catch (error) {
        console.error('Error checking album:', error);
        setLoading(false);
      }
    };

    checkAlbumExists();
  }, [albumSlug, navigate]);

  if (loading) {
    return <AppLoadingState />;
  }

  if (!albumExists) {
    return <NotFound />;
  }

  return null;
};

export default AlbumRedirect;
